// ----------------------------------------------------------------------- imports externos
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

// ----------------------------------------------------------------------- imports internos
import { ultimosAccesos } from "../services/accesos";
import PuertaCerrada from "../components/funcionales/PuertaCerrada";

/* Accesos al hub: quién lo usa, y hace cuánto.
 *
 * Nació de una pregunta concreta («¿Gula hace 6 días no lo usa?») que el hub
 * no podía contestar. La trampa que esta pantalla evita: el ÚLTIMO LOGIN
 * miente — quien deja la sesión abierta pone la clave una vez y no vuelve a
 * loguearse nunca. Lo que dice si una persona USA el hub es la última
 * actividad (su sesión refrescándose), y por eso la lista se ordena por eso.
 */

const TZ = "America/Argentina/Buenos_Aires";

const cuando = (iso) => {
  if (!iso) return null;
  return new Date(iso).toLocaleString("es-AR", {
    timeZone: TZ,
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/* «hoy» / «ayer» / «hace N días»: el número que se busca al abrir esto. */
export const haceCuanto = (iso, ahora = Date.now()) => {
  if (!iso) return "nunca entró";
  const dias = Math.floor((ahora - new Date(iso).getTime()) / 86400000);
  if (dias <= 0) return "hoy";
  if (dias === 1) return "ayer";
  return `hace ${dias} días`;
};

const Accesos = () => {
  const { permisos = null } = useOutletContext() || {};
  const permitido = permisos !== null && permisos.includes("ver.sistema");

  const [datos, setDatos] = useState(undefined); // undefined = cargando
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!permitido) return;
    ultimosAccesos()
      .then((filas) =>
        setDatos(
          // Los que se movieron último, arriba; los que nunca entraron, abajo.
          [...filas].sort((a, b) =>
            String(b.ultima_actividad || "").localeCompare(
              String(a.ultima_actividad || ""),
            ),
          ),
        ),
      )
      .catch(() => setError(true));
  }, [permitido]);

  if (permisos !== null && !permitido) {
    return <PuertaCerrada />;
  }

  if (error) {
    return (
      <div className="panel-aviso"><h3>No se pudo consultar</h3></div>
    );
  }

  return (
    <>
      {datos !== undefined && datos.length === 0 && (
        <div className="panel-aviso suave">
          <h3>La base no devolvió accesos</h3>
        </div>
      )}

      {datos !== undefined && datos.length > 0 && (
        <div className="tabla-wrap">
          <table className="tabla fija">
            <thead>
              <tr>
                <th>Quién</th>
                <th>Última actividad</th>
                <th>Último login</th>
              </tr>
            </thead>
            <tbody>
              {datos.map((a) => (
                <tr key={a.mail}>
                  <td>{a.mail}</td>
                  <td>
                    <b>{haceCuanto(a.ultima_actividad)}</b>{" "}
                    {a.ultima_actividad && (
                      <span className="sub">{cuando(a.ultima_actividad)}</span>
                    )}
                  </td>
                  <td>
                    {cuando(a.ultimo_login) || (
                      <span className="tenue">nunca</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

    </>
  );
};

export default Accesos;
